import { StyledHeadTitle } from '@lib/common';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ListPage = styled.section.withConfig({
  displayName: "class-announcement-list-layoutcomponent__ListPage",
  componentId: "sc-bietej-0"
})(["display:flex;flex:1;flex-direction:column;min-height:0;min-width:0;height:100%;padding:16px 24px;"]);
var ListHeader = styled.div.withConfig({
  displayName: "class-announcement-list-layoutcomponent__ListHeader",
  componentId: "sc-bietej-1"
})(["display:flex;align-items:center;justify-content:space-between;flex-shrink:0;flex-wrap:wrap;gap:16px;margin-bottom:20px;"]);
export var ClassAnnouncementListLayout = function ClassAnnouncementListLayout(_ref) {
  var title = _ref.title,
      actions = _ref.actions,
      children = _ref.children;
  return /*#__PURE__*/_jsxs(ListPage, {
    children: [/*#__PURE__*/_jsxs(ListHeader, {
      children: [/*#__PURE__*/_jsx(StyledHeadTitle, {
        children: title
      }), actions]
    }), children]
  });
};